import { baseApi } from '../app/baseApi';
import type { Meeting } from '../../../shared/src/types/Meeting';

export interface CreateMeetingRequest {
  meetingData: any;
  financialData: any;
}

export const meetingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMeetings: builder.query<Meeting[], { familyId: string; dateFilter?: string }>({
      query: ({ familyId, dateFilter }) => ({
        url: '/meetings',
        params: {
          familyId,
          sort: 'dateDesc',
          ...(dateFilter ? { date: dateFilter } : {}),
        },
      }),
      transformResponse: (response: { success: boolean; data: Meeting[] }) => {
        return response.data; 
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Meeting' as const, id })),
              { type: 'Meeting', id: 'LIST' },
            ]
          : [{ type: 'Meeting', id: 'LIST' }],
    }),

    updateMeeting: builder.mutation<Meeting, { id: string; updatedData: Partial<Meeting> }>({
      query: ({ id, updatedData }) => ({
        url: `/meetings/${id}`,
        method: 'PATCH',
        body: updatedData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Meeting', id },
        { type: 'Meeting', id: 'LIST' },
      ],
    }),

    deleteMeeting: builder.mutation<void, string>({
      query: (id) => ({
        url: `/meetings/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Meeting', id: 'LIST' }],
    }),

    createMeeting: builder.mutation<Meeting, CreateMeetingRequest>({
      query: ({ meetingData, financialData }) => ({
        url: '/meetings/dashboard',
        method: 'POST',
        body: {
          meetingData,
          financialData,
        },
      }),
      invalidatesTags: [{ type: 'Meeting', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMeetingsQuery,
  useUpdateMeetingMutation,
  useDeleteMeetingMutation,
  useCreateMeetingMutation,
} = meetingsApi;
